import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function CheckSmall({
  className,
  fillPrimary = colors.neutral100,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3 8.11538L6.66667 11.5L13 4"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
